import Products from "./Products";

const SubscriptionProducts = () => {
	return (
		<div className="flex flex-col w-full">
			<Products />
		</div>
	);
};

export default SubscriptionProducts;
